<template>
    <div class="date_picker">
        <div class="trigger" @click="showPickerBody">
            <slot></slot>
        </div>
        <div class="date_picker_pannel">
            <transition name="fade">
                <div v-if="isShow">
                    <div @click="showPickerBody" class="shade">
                    </div>
                    <div class="date_picker_body">
                        <div class="header">
                            <div @click="switchMonth(-1)" class="prev"></div>
                            <div class="year_month">
                                <span class="month" v-text="curShowMonthCN"></span>&nbsp;<span class="year" v-text="curShowYear"></span>
                            </div>
                            <div @click="switchMonth(1)" class="next"></div>
                        </div>
                        <ul class="week_day">
                            <li>日</li>
                            <li>一</li>
                            <li>二</li>
                            <li>三</li>
                            <li>四</li>
                            <li>五</li>
                            <li>六</li>
                        </ul>
                        <ul class="day">
                            <li @click="selectDate(date)" :class="{'today':isToday(date),'not_in_cur_show_month':isNotInCurShowMonth(date),'disabled':disabled(date),'selected':checkDateSelected(date)}" v-for="date in dateArray" v-text="theDate(date)"></li>
                        </ul>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import Vue from "vue"
import "../../../../service/date.js";
let vue = new Vue();
export default {
    name: 'datePicker',
    props: {
        selectedDate: {
            type: String,
        },
        disabled: {
            type: Function,
            default: (date) => {
                return false;
            }
        }
    },
    data() {
        return {
            isShow: false,
            now: this.formatDate(new Date(), "yyyy-MM-dd"),
            curShowMonthDate: '',
            monthArray: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            dateArray: [],
            $pickerPannel: ''
        }
    },
    created() {},
    mounted() {
        this.handleDom();
        this.initCurMonthDate();
        this.constructData();
    },
    methods: {
        /**
         * [handleDom description] 处理dom节点，适应全局定位渲染
         * @return {[type]} [description]
         */
        handleDom() {
            let $el = $(this.$el);
            this.$pickerPannel = $el.find(".date_picker_pannel");
            this.$pickerPannel.remove();
            $("body").append(this.$pickerPannel);
        },
        /**
         * [selectDate description] 选中日期
         * @param  {[type]} date [description] 被选中日期
         * @return {[type]}      [description]
         */
        selectDate(date) {
            if (this.disabled(date)) return;
            this.$emit("update:selectedDate", this.formatDate(date, "yyyy-MM-dd"));
            this.$emit("callback");
            this.isShow = false;
        },
        /**
         * [initCurMonthDate description] 初始化“当前展示月日期”
         * @return {[type]} [description]
         */
        initCurMonthDate() {
            //this.selectedDate = this.selectedDate ? this.selectedDate : this.formatDate(new Date(), "yyyy/MM/dd");
            let baseDate = this.selectedDate ? this.selectedDate : this.formatDate(new Date(), "yyyy-MM-dd");
            let date = new Date(baseDate);
            date.setDate(1);
            date.setHours(0);
            date.setMinutes(0);
            this.curShowMonthDate = date;
        },
        /**
         * [showPickerBody description] 显示窗体
         * @return {[type]} [description]
         */
        showPickerBody() {
            this.isShow = !this.isShow;
        },
        /**
         * [constructData description] 构建数据
         * @return {[type]} [description]
         */
        constructData() {
            this.dateArray = [];
            let date = new Date(this.curShowMonthDate.toString());
            while (this.curShowMonthDate.getMonth() == date.getMonth()) {
                this.dateArray.push(new Date(date.toString())); //复制日期对象
                date.setDate(date.getDate() + 1);
            }
            while (this.dateArray[0].getDay() != 0) { //补充当前显示月前一个月的数据，对齐星期
                let date = new Date(this.dateArray[0].toString()); //复制日期对象
                date.setDate(date.getDate() - 1);
                this.dateArray.unshift(date);
            }
            while (this.dateArray[this.dateArray.length - 1].getDay() != 6) { //补充当前显示月下一个月的数据，对齐星期
                let date = new Date(this.dateArray[this.dateArray.length - 1].toString()); //复制日期对象
                date.setDate(date.getDate() + 1);
                this.dateArray.push(date);
            }
        },
        /**
         * [switchMonth description] 切换月份
         * @param  {[type]} value [description] 叠加值
         * @return {[type]}       [description]
         */
        switchMonth(value) {
            let date = new Date(this.curShowMonthDate.toString()); //这样绕着写是为了触发计算属性
            date.setMonth(date.getMonth() + value);
            this.curShowMonthDate = date;
            this.$emit("changedMonth", date);
            this.constructData();
        }
    },
    computed: {
        /**
         * [curShowMonthCN description] 当前展示月中文
         * @return {[type]} [description]
         */
        curShowMonthCN() {
            return this.monthArray[this.curShowMonthDate.getMonth()]
        },
        /**
         * [curShowYear description] 当前展示年
         * @return {[type]} [description]
         */
        curShowYear() {
            return this.curShowMonthDate.getFullYear();
        },
        /**
         * [theDate description] 面板日期显示
         * @return {[type]} [description]
         */
        theDate() {
            return date => {
                let theDate = date.getDate();
                theDate = theDate > 9 ? theDate : '0' + theDate;
                return theDate;
            }
        },
        /**
         * [isToday description] 是否是今天
         * @return {Boolean} [description]
         */
        isToday() {
            return date => {
                let theDate = date.getDate();
                let theMonth = date.getMonth();
                let theYear = date.getFullYear();
                return new Date().getDate() == theDate && new Date().getMonth() == theMonth && new Date().getFullYear() == theYear;
            }
        },
        /**
         * [isNotInCurShowMonth description] 是否在当前显示月份内
         * @return {Boolean} [description]
         */
        isNotInCurShowMonth() {
            return date => {
                let theMonth = date.getFullYear() + date.getMonth();
                let month = this.curShowMonthDate.getFullYear() + this.curShowMonthDate.getMonth();
                return theMonth != month;
            }
        },
        /**
         * [checkDateSelected description] 判断被校验日期是不是被选中日期
         * @return {[type]} [description]
         */
        checkDateSelected() {
            return date => {
                if (!this.selectedDate) return false;
                let selectedDate = this.formatDate(new Date(this.selectedDate), "yyyy-MM-dd");
                date = this.formatDate(date, "yyyy-MM-dd");
                return selectedDate == date;
            }
        }
    }
}
</script>
<style lang='less' scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.date_picker_pannel {
    position: fixed;
    z-index: 999;

    &>div {
        .shade {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4)
        }

        .date_picker_body {
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            top: 76px;
            width: 334px;
            min-height: 340px;
            background: rgba(252, 252, 252, 1);
            box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
            border-radius: 4px;
            border: 1px solid rgba(210, 214, 220, 0.4);
            padding-bottom: 14px;
            box-sizing: border-box;

            .header {
                width: 100%;
                height: 53px;
                line-height: 53px;

                &>div {
                    display: inline-block;

                    &.prev {
                        cursor: pointer;

                        &::before {
                            content: ' ';
                            width: 0;
                            height: 0;
                            border-width: 7px 7px 7px 0px;
                            border-color: transparent #909399 transparent transparent;
                            position: absolute;
                            left: 20px;
                            top: 19px;
                            border-style: solid;
                            cursor: pointer;
                        }
                    }

                    &.year_month {
                        // width: calc(100% - 58px);
                        width: 100%;
                        color: rgba(42, 42, 42, 1);
                        font-family: FZBIAOYSJW--GB1-0, FZBIAOYSJW--GB1;
                        font-size: 18px;
                        text-align: center;
                    }

                    &.next {
                        &::after {
                            content: ' ';
                            width: 0;
                            height: 0;
                            border-width: 7px 0px 7px 7px;
                            border-color: transparent transparent transparent #909399;
                            position: absolute;
                            right: 20px;
                            top: 19px;
                            border-style: solid;
                            cursor: pointer;
                        }
                    }
                }
            }

            .week_day {
                width: 100%;
                box-sizing: border-box;
                font-size: 0;
                display: inline-block;
                padding-left: 35px;
                margin-bottom: 14px;

                li {
                    float: left;
                    font-size: 16px;
                    font-family: FZXIYSJW--GB1-0, FZXIYSJW--GB1;
                    margin-right: 25px;
                }
            }

            .day {
                width: 100%;
                box-sizing: border-box;
                display: inline-block;
                padding-left: 23px;

                li {
                    float: left;
                    width: 40px;
                    height: 30px;
                    display: inline-block;
                    border-radius: 45px;
                    cursor: pointer;
                    text-align: center;
                    line-height: 29px;
                    font-size: 14px;
                    margin-bottom: 14px;

                    &.selected {
                        background: rgba(224, 54, 38, 1);
                        color: white !important;
                    }

                    &.today {
                        border: 0.5px solid rgba(224, 54, 38, 1);
                        box-sizing: border-box;
                    }

                    &.disabled {
                        color: rgba(53, 64, 82, 0.5);
                        cursor: not-allowed;
                    }

                    &.not_in_cur_show_month {
                        color: rgba(53, 64, 82, 0.5);
                    }
                }
            }
        }
    }
}
</style>